import React, { Component } from 'react';
import { Redirect } from 'react-router'

// material UI components
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import ErrorIcon from '@material-ui/icons/Error';
// material UI components
import axios from 'axios';

class Landing extends Component {

    constructor() {
        super();
        this.login = this.login.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.getuserInfo = this.getuserInfo.bind(this);

        this.state = {
            user_name: '',
            password: '',
            open: false
        };
    }

    componentWillMount() {
        let id = localStorage.getItem("tigoID");
        if (id !== null) {
            let t_ = this;
            axios.post(this.props.url + "get_user_info", {
                id: id
            })
                .then(function (response) {
                    if (response.data !== 0) {
                        t_.props.changeLogged(1, response.data);
                    } else {
                        t_.setState({ open: true });
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
    }

    getuserInfo(id) {
        let t_ = this;
        axios.post(this.props.url + "get_user_info", {
            id: id
        })
            .then(function (response) {
                if (response.data !== 0) {
                    t_.props.changeLogged(1, response.data);
                } else {
                    t_.setState({ open: true });
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    //Handle close of the snack########################################################################
    handleClose = (e, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        this.setState({ open: false });
    };
    //Handle close of the snack########################################################################

    //Handle Input change########################################################################
    handleChange(e) {
        const target = e.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
            [name]: value
        });
    }
    //Handle Input change########################################################################

    //Login########################################################################
    login(e) {
        let t_ = this;
        //Get the news
        axios.post(this.props.url + "login", {
            params: {
                user_name: this.state.user_name,
                password: this.state.password
            }
        })
            .then(function (response) {
                if (response.data !== 0) {
                    t_.props.changeLogged(1, response.data);
                    localStorage.setItem("tigoID", response.data.id);
                    t_.getuserInfo(response.data.id);
                    t_.props.getLocation();
                } else {
                    t_.setState({ open: true });
                }
            })
            .catch(function (error) {
                console.log(error);
            });

        e.preventDefault();
    }

    //Render########################################################################
    render() {
        return (
            <div className="landing">
                {
                    this.props.isLoggedIn ? (<Redirect to="/mapa" />) : ""
                }
                <Card className="form">
                    <CardContent>
                        <form onSubmit={this.login}>
                            <div className="logo">
                                <img src="images/logo.png" alt="" />
                            </div>
                            <div className="field">
                                <TextField
                                    required
                                    id="user"
                                    name="user_name"
                                    label="Usuario"
                                    className='text-field'
                                    autoFocus={true}
                                    value={this.state.user_name}
                                    onChange={this.handleChange}
                                    autoComplete="off"
                                />
                            </div>
                            <div className="field">
                                <TextField
                                    required
                                    id="password"
                                    name="password"
                                    label="Contraseña"
                                    type="password"
                                    autoComplete="current-password"
                                    className='text-field'
                                    value={this.state.password}
                                    onChange={this.handleChange}
                                />
                            </div>
                            <div className="field">
                                <Button variant="contained" type="submit" color="primary" className="text-field">
                                    Ingresar
                                </Button>
                            </div>
                        </form>
                    </CardContent>
                </Card>
                <Snackbar
                    className="invalid-user"
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    open={this.state.open}
                    autoHideDuration={6000}
                    onClose={this.handleClose}
                    ContentProps={{
                        'aria-describedby': 'message-id',
                        headlineMapping: {
                            body1: "div",
                            body2: "div"
                        }
                    }}
                    message={<span className='snackbar-content'><ErrorIcon /> Usuario Invalido</span>}
                    action={[
                        <IconButton
                            key="close"
                            aria-label="Close"
                            color="inherit"
                            className="close-snack"
                            onClick={this.handleClose}
                        >
                            <CloseIcon />
                        </IconButton>,
                    ]}
                />
            </div>
        );
    }
}
export default Landing;


// WEBPACK FOOTER //
// ./src/components/Landing.js